//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "searchResult",
  data() {
    return {
      searchKey: "",
      pageNo: 1, //頁碼
      pageSize: 100, //每頁顯示數量
      resultData: [],
      iconAuthor: require("@/assets/image/icon/icon_author.png"),
      iconCart: require("@/assets/image/icon/icon_cart.png"),
      isNative: false,
      rateConfig: JSON.parse(localStorage.getItem('rateConfig')),
    };
  },
  created: function() {
    // console.log(this.$route);
    // this.searchKey = this.$route.query.key;
  },
  mounted: function() {
    this.searchKey = this.$route.query.key;
    this.searchCode = this.$route.query.code;
    this.getData();
  },
  methods: {
    //返回上一页
    onClickLeft(){
      this.$router.back()
    },
    backSearch(){
      this.$router.back()
    },
    gotoDetail(id, code) {
      let obj = {};
      obj["router"] = this.$router;
      if (code != "ebook" && code != "video") {
        obj["path"] = this.UTILS.splitUrl("detail");
        obj["query"] = { id: id };
        this.GLOBAL_.ccApp.openTo(obj);
      } else if (code == "ebook") {
        obj["path"] = this.UTILS.splitUrl("ebookDetail");
        obj["query"] = { id: id };
        this.GLOBAL_.ccApp.openTo(obj);
      } else if (code == "video") {
        obj["path"] = this.UTILS.splitUrl("videoDetail");
        obj["query"] = { id: id };
        this.GLOBAL_.ccApp.openTo(obj);
      }
    },
    getData() {
      this.$toast.loading();
      let postD = {
        keyword: this.searchKey,
        code: this.searchCode,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };

      this.GLOBAL_.ccRequest.doAxios(this.CONFIG.COLUMN.SEARCHMOREBYKEYWORD, postD, "GET")
        .then(res => {
          this.resultData = res[0];
          this.$toast.close();
        })
        .catch(err => {
          // console.log("更多搜索內容加載失敗");
          this.$toast.close();
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    //console.log('to', to.path, to);
    if(to.path == '/detail' || to.path == '/ebookDetail' || to.path == '/audioDetail' || to.path == '/videoDetail') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  }
};



// WEBPACK FOOTER //
// ./src/pages/search/searchResult.vue